import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import { ITextProps } from '../../constants/commonTypes';

const Text = (props: ITextProps) => {

  const {
    children,
    fontSize,
    fontStyle,
    fontWeight,
    fontFamily,
    letterSpacing,
    lineHeight,
    textAlign,
    ...rest
  } = props

  return (
    <Typography component='div'>
      <Box
        fontWeight={fontWeight}
        fontSize={fontSize}
        fontStyle={fontStyle}
        fontFamily={fontFamily}
        letterSpacing={letterSpacing}
        lineHeight={lineHeight}
        textAlign={textAlign}
        {...rest}
      >
        {children}
      </Box>
    </Typography>
  );
}

Text.defaultProps = {
  children: '',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 'fontWeightRegular',
  fontFamily: "'Lato', sans-serif",
  letterSpacing: 0.2,
  lineHeight: "normal",
  textAlign: "left",
  className: ""
}


Text.propTypes = {
  children: PropTypes.any,
  fontSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  fontStyle: PropTypes.oneOf(['normal', 'italic', 'oblique']),
  fontWeight: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['fontWeightLight', 'fontWeightRegular', 'fontWeightMedium', 'fontWeightBold']),
  ]),
  fontFamily: PropTypes.string,
  letterSpacing: PropTypes.number,
  lineHeight: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  textAlign: PropTypes.string,
  className: PropTypes.string,
}


export default Text;